import { useThree } from '@react-three/fiber';
import { memo } from 'react';

import CloudOverlay from '0_canvas/CloudOverlay/CloudOverlay';
import { useCloudOverlayStore } from 'state/cloudOverlayStore';
import { useThreeStore } from 'state/threeStore';

const CloudOverlayScene = () => {
  const { size } = useThree();
  const isTilesRendered = useThreeStore(s => s.tiles.isRendered);
  const tilesStage = useThreeStore(s => s.tiles.stage);
  const isCloudsOverlayVisible = useCloudOverlayStore(s => s.visible);

  return (
    <CloudOverlay
      color={'#fff'}
      opacity={
        size?.width > 1200 &&
        Boolean(isTilesRendered) &&
        Boolean(tilesStage === 'VISIBLE') &&
        isCloudsOverlayVisible
          ? 0.2
          : 0
      }
    />
  );
};

export default memo(CloudOverlayScene);
